<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>